import { Form, Input } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  element: TaskFormElement
  required?: boolean
}

export const TextareaElement = ({ element, required }: Props) => {
  return (
    <Form.Item name={element.name} label={element.label} rules={[{ required }]}>
      <Input.TextArea />
    </Form.Item>
  )
}
